var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('inspect-order',{ref:"inspectOrder",attrs:{"order-status-data":_vm.orderStatusData,"owners":_vm.owners},on:{"rowClick":_vm.rowClick}}),_c('inspect-detail',{ref:"inspectDetail",staticStyle:{"margin-top":"2px"},on:{"rowDblClick":_vm.rowDblClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }